export default "__VITE_ASSET__Be8X5uMA__"